import { Section } from '@/components/shared/Content';
import JoinCTA from '@/components/shared/JoinCTA';
import { Box, Flex, font, useViewportSize } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import Image from 'next/image';
import type React from 'react';
import styled from 'styled-components';
import coinToHeart from '@/static/assets/giveback_2024/coin_to_heart.gif';
import { GBSectionParagraph, GBSectionTitle } from './StyledElements';

const ContentWrapper = styled(Flex)`
  max-width: 825px;
`;

const JoinUsSectionTitle = styled(GBSectionTitle)`
  text-align: center;
`;

const JoinUsSectionParagraph = styled(GBSectionParagraph)`
  text-align: center;

  ${MEDIA_QUERIES.tabletAndDesktop`
        white-space: initial;
        text-wrap: balance;
    `}
`;

const CTA = styled(JoinCTA)`
  &&& {
    display: block;
    width: 265px;
    padding: 18px 30px;
    border-radius: 8px;
    text-decoration: none;
    ${font('main', {
      fontSize: '1.4rem',
      lineHeight: '2.2rem',
      fontWeight: 700,
    })};

    &:hover {
      text-decoration: none;
    }

    ${MEDIA_QUERIES.tablet`
            width: auto;
            padding: 12px 30px;
        `}

    ${MEDIA_QUERIES.tabletAndDesktop`
            width: auto;
            padding: 12px 30px;
        `}

        @media (max-width: 355px) {
      width: 100%;
    }
  }
`;

export interface JoinTheGivebackProps {
  title: string;
  mainCtaLabel: string;
  subtitle: string;

  animatedImage?: StaticImageData;
}

export const JoinTheGiveback: React.FC<JoinTheGivebackProps> = ({
  title,
  mainCtaLabel,
  subtitle,
  animatedImage = coinToHeart,
}) => {
  const { isMobileViewport } = useViewportSize();
  return (
    <Section pt={[40, 70]} pb={[40, 70]} px={[20]} darkBackground>
      <Image
        src={animatedImage}
        alt="Join Giveback"
        style={{
          pointerEvents: 'none',
          height: 'auto',
          width: isMobileViewport ? 140 : 182,
        }}
      />

      <Box mt={[30, 30]}>
        <JoinUsSectionTitle>{title}</JoinUsSectionTitle>
      </Box>
      <ContentWrapper flexDirection="column" alignItems="center" width={1} pt={20} pb={60}>
        <JoinUsSectionParagraph>{subtitle}</JoinUsSectionParagraph>
      </ContentWrapper>
      <CTA size="small" flavor="primary" glowing>
        {mainCtaLabel}
      </CTA>
    </Section>
  );
};
